import CreationInvitationHeader from 'components/common/CreationInvitationHeader'

const CreateScenarioHead = () => (
  <CreationInvitationHeader
    buttonText="New Scenario"
    heading="Simulate an outage."
    link="/scenarios/new"
    subheading="Validate how your system responds to common failures."
  />
)

export default CreateScenarioHead
